import { createAction } from "redux-actions";

import * as Shops from "../api/shops";
import {
  ADD_AMAZON_AUTH_TOKEN_FAILURE,
  ADD_AMAZON_AUTH_TOKEN_SUCCESS,
  ADD_BIGCARTEL_AUTH_TOKEN_FAILURE,
  ADD_BIGCARTEL_AUTH_TOKEN_SUCCESS,
  ADD_EBAY_AUTH_TOKEN_FAILURE,
  ADD_EBAY_AUTH_TOKEN_SUCCESS,
  ADD_ETSY_AUTH_TOKEN_FAILURE,
  ADD_ETSY_AUTH_TOKEN_SUCCESS,
  ADD_SHOPIFY_ANONY_TOKEN_FAILURE,
  ADD_SHOPIFY_ANONY_TOKEN_SUCCESS,
  ADD_SHOPIFY_AUTH_FAILURE,
  ADD_SHOPIFY_AUTH_SUCCESS,
  ADD_SHOPIFY_TOKEN_FAILURE,
  ADD_SHOPIFY_TOKEN_SUCCESS,
  ADD_SHOP_FAILURE,
  ADD_SHOP_SUCCESS,
  ADD_SQUARESPACE_AUTH_TOKEN_FAILURE,
  ADD_SQUARESPACE_AUTH_TOKEN_SUCCESS,
  ADD_TO_CHANNEL_FAILURE,
  ADD_TO_CHANNEL_SUCCESS,
  ADD_WOOCOMMERCE_AUTH_FAILURE,
  ADD_WOOCOMMERCE_AUTH_SUCCESS,
  DELETE_SHOP_FAILURE,
  DELETE_SHOP_SUCCESS,
  REQUEST_AMAZON_AUTH_URL_FAILURE,
  REQUEST_AMAZON_AUTH_URL_SUCCESS,
  REQUEST_BIGCARTEL_AUTH_URL_FAILURE,
  REQUEST_BIGCARTEL_AUTH_URL_SUCCESS,
  REQUEST_EBAY_AUTH_URL_FAILURE,
  REQUEST_EBAY_AUTH_URL_SUCCESS,
  REQUEST_ETSY_AUTH_URL_FAILURE,
  REQUEST_ETSY_AUTH_URL_SUCCESS,
  REQUEST_ETSY_CATEGORIES_FAILURE,
  REQUEST_ETSY_CATEGORIES_SUCCESS,
  REQUEST_ETSY_TEMPLATES_FAILURE,
  REQUEST_ETSY_TEMPLATES_SUCCESS,
  REQUEST_PRODUCT_SHOPS_FAILURE,
  REQUEST_PRODUCT_SHOPS_SUCCESS,
  REQUEST_SHOPS_FAILURE,
  REQUEST_SHOPS_SUCCESS,
  REQUEST_SHOP_DETAILS_FAILURE,
  REQUEST_SHOP_DETAILS_SUCCESS,
  REQUEST_SQUARESPACE_AUTH_URL_FAILURE,
  REQUEST_SQUARESPACE_AUTH_URL_SUCCESS,
  REQUEST_SQUARE_AUTH_URL_FAILURE,
  REQUEST_SQUARE_AUTH_URL_SUCCESS,
  SQUARE_CALLBACK_FAILURE,
  SQUARE_CALLBACK_SUCCESS,
  SHIP_STATION_SUCCESS,
  SHIP_STATION_FAILURE,
  SAVE_SHIP_STATION_AUTH_SUCCESS,
  SAVE_SHIP_STATION_AUTH_FAILURE,
  ADD_SHOP_AUTH_SUCCESS,
  ADD_SHOP_AUTH_FAILURE,
  UPDATE_SHOP_SUCCESS,
  UPDATE_SHOP_FAILURE,
  GET_PRODUCT_OF_SHOP_SUCCESS,
  GET_PRODUCT_OF_SHOP_FAILURE,
  UPDATE_PRODUCT_VISIBILITY_SUCCESS,
  UPDATE_PRODUCT_VISIBILITY_FAILURE,
  UPDATE_SHOP_HOME_PAGE_SETTINGS_SUCCESS,
  UPDATE_SHOP_HOME_PAGE_SETTINGS_FAILURE,
  GET_SHOP_HOME_PAGE_SETTINGS_SUCCESS,
  GET_SHOP_HOME_PAGE_SETTINGS_FAILURE,
  CONNECT_SHOP_SUCCESS,
  CONNECT_SHOP_FAILURE,
  UPDATE_SHOP_DOMAINS_SUCCESS,
  UPDATE_SHOP_DOMAINS_FAILURE,
  VERIFY_SHOP_DOMAINS_SUCCESS,
  VERIFY_SHOP_DOMAINS_FAILURE,
} from "../constants/actionTypes";

const requestShopsSuccess = createAction(REQUEST_SHOPS_SUCCESS);
const requestShopsFailure = createAction(REQUEST_SHOPS_FAILURE);

export function requestShops(params, id) {
  return (dispatch) =>
    Shops.requestShops(params, id)
      .then((data) => dispatch(requestShopsSuccess(data)))
      .catch((error) => dispatch(requestShopsFailure(error)));
}

const requestShopDetailsSuccess = createAction(REQUEST_SHOP_DETAILS_SUCCESS);
const requestShopDetailsFailure = createAction(REQUEST_SHOP_DETAILS_FAILURE);

export function requestShopDetails(id, query) {
  return (dispatch) =>
    Shops.requestShopDetails(id, query)
      .then((data) => dispatch(requestShopDetailsSuccess(data)))
      .catch((error) => dispatch(requestShopDetailsFailure(error)));
}

const addShopSuccess = createAction(ADD_SHOP_SUCCESS);
const addShopFailure = createAction(ADD_SHOP_FAILURE);

export function addShop(params) {
  return (dispatch) =>
    Shops.addShop(params)
      .then((data) => dispatch(addShopSuccess(data)))
      .catch((error) => dispatch(addShopFailure(error)));
}

const updateShopSuccess = createAction(UPDATE_SHOP_SUCCESS);
const updateShopFailure = createAction(UPDATE_SHOP_FAILURE);

export function updateShop(id, params) {
  return (dispatch) =>
    Shops.updateShop(id, params)
      .then((data) => dispatch(updateShopSuccess(data)))
      .catch((error) => dispatch(updateShopFailure(error)));
}

const updateShopHomePageSettingsSuccess = createAction(
  UPDATE_SHOP_HOME_PAGE_SETTINGS_SUCCESS
);
const updateShopHomePageSettingsFailure = createAction(
  UPDATE_SHOP_HOME_PAGE_SETTINGS_FAILURE
);

export function updateShopHomePageSettings(id, params) {
  return (dispatch) =>
    Shops.updateShopHomePageSettings(id, params)
      .then((data) => dispatch(updateShopHomePageSettingsSuccess(data)))
      .catch((error) => dispatch(updateShopHomePageSettingsFailure(error)));
}

const getShopHomePageSettingsSuccess = createAction(
  GET_SHOP_HOME_PAGE_SETTINGS_SUCCESS
);
const getShopHomePageSettingsFailure = createAction(
  GET_SHOP_HOME_PAGE_SETTINGS_FAILURE
);

export function getShopHomePageSettings(id, params) {
  return (dispatch) =>
    Shops.getShopHomePageSettings(id, params)
      .then((data) => dispatch(getShopHomePageSettingsSuccess(data)))
      .catch((error) => dispatch(getShopHomePageSettingsFailure(error)));
}

const deleteShopSuccess = createAction(DELETE_SHOP_SUCCESS);
const deleteShopFailure = createAction(DELETE_SHOP_FAILURE);

export function deleteShop(id) {
  return (dispatch) =>
    Shops.deleteShop(id)
      .then(({ data }) => dispatch(deleteShopSuccess({ id, data })))
      .catch((error) => dispatch(deleteShopFailure(error)));
}

const requestEtsyAuthUrlSuccess = createAction(REQUEST_ETSY_AUTH_URL_SUCCESS);
const requestEtsyAuthUrlFailure = createAction(REQUEST_ETSY_AUTH_URL_FAILURE);

export function requestEtsyAuthUrl() {
  return (dispatch) =>
    Shops.requestEtsyAuthUrlV2()
      .then((data) => dispatch(requestEtsyAuthUrlSuccess(data)))
      .catch((error) => dispatch(requestEtsyAuthUrlFailure(error)));
}
const addEtsyAuthTokenSuccess = createAction(ADD_ETSY_AUTH_TOKEN_SUCCESS);
const addEtsyAuthTokenFailure = createAction(ADD_ETSY_AUTH_TOKEN_FAILURE);

export function addEtsyAuthToken(params) {
  return (dispatch) =>
    Shops.addEtsyAuthTokenV2(params)
      .then((data) => dispatch(addEtsyAuthTokenSuccess(data)))
      .catch((error) => dispatch(addEtsyAuthTokenFailure(error)));
}

const requestAmazonAuthUrlSuccess = createAction(
  REQUEST_AMAZON_AUTH_URL_SUCCESS
);
const requestAmazonAuthUrlFailure = createAction(
  REQUEST_AMAZON_AUTH_URL_FAILURE
);

export function requestAmazonAuthUrl() {
  return (dispatch) =>
    Shops.requestAmazonAuthUrl()
      .then((data) => dispatch(requestAmazonAuthUrlSuccess(data)))
      .catch((error) => dispatch(requestAmazonAuthUrlFailure(error)));
}
const addAmazonAuthTokenSuccess = createAction(ADD_AMAZON_AUTH_TOKEN_SUCCESS);
const addAmazonAuthTokenFailure = createAction(ADD_AMAZON_AUTH_TOKEN_FAILURE);

export function addAmazonAuthToken(params) {
  return (dispatch) =>
    Shops.addAmazonAuthToken(params)
      .then((data) => dispatch(addAmazonAuthTokenSuccess(data)))
      .catch((error) => dispatch(addAmazonAuthTokenFailure(error)));
}

const requestSquareAuthUrlSuccess = createAction(
  REQUEST_SQUARE_AUTH_URL_SUCCESS
);
const requestSquareAuthUrlFailure = createAction(
  REQUEST_SQUARE_AUTH_URL_FAILURE
);

export function requestSquareAuthUrl() {
  return (dispatch) =>
    Shops.requestSquareAuthUrl()
      .then((data) => dispatch(requestSquareAuthUrlSuccess(data)))
      .catch((error) => dispatch(requestSquareAuthUrlFailure(error)));
}

const squareCallbackSuccess = createAction(SQUARE_CALLBACK_SUCCESS);
const squareCallbackFailure = createAction(SQUARE_CALLBACK_FAILURE);

export function squareCallback(params) {
  return (dispatch) =>
    Shops.squareCallback(params)
      .then((data) => dispatch(squareCallbackSuccess(data)))
      .catch((error) => dispatch(squareCallbackFailure(error)));
}

const addShopifyAuthSuccess = createAction(ADD_SHOPIFY_AUTH_SUCCESS);
const addShopifyAuthFailure = createAction(ADD_SHOPIFY_AUTH_FAILURE);

export function addShopifyAuth(params) {
  return (dispatch) =>
    Shops.addShopifyAuth(params)
      .then((data) => dispatch(addShopifyAuthSuccess(data)))
      .catch((error) => dispatch(addShopifyAuthFailure(error)));
}

const addShopifyTokenSuccess = createAction(ADD_SHOPIFY_TOKEN_SUCCESS);
const addShopifyTokenFailure = createAction(ADD_SHOPIFY_TOKEN_FAILURE);

export function addShopifyToken(params) {
  return (dispatch) =>
    Shops.addShopifyToken(params)
      .then((data) => dispatch(addShopifyTokenSuccess(data)))
      .catch((error) => dispatch(addShopifyTokenFailure(error)));
}

const addShopifyAnonyTokenSuccess = createAction(
  ADD_SHOPIFY_ANONY_TOKEN_SUCCESS
);
const addShopifyAnonyTokenFailure = createAction(
  ADD_SHOPIFY_ANONY_TOKEN_FAILURE
);

export function addShopifyAnonyToken(params) {
  return (dispatch) =>
    Shops.addShopifyAnonyToken(params)
      .then((data) => dispatch(addShopifyAnonyTokenSuccess(data)))
      .catch((error) => dispatch(addShopifyAnonyTokenFailure(error)));
}

const addWoocommerceAuthSuccess = createAction(ADD_WOOCOMMERCE_AUTH_SUCCESS);
const addWoocommerceAuthFailure = createAction(ADD_WOOCOMMERCE_AUTH_FAILURE);

export function addWoocommerceAuth(params) {
  return (dispatch) =>
    Shops.addWoocommerceAuth(params)
      .then((data) => dispatch(addWoocommerceAuthSuccess(data)))
      .catch((error) => dispatch(addWoocommerceAuthFailure(error)));
}

const requestProductShopsSuccess = createAction(REQUEST_PRODUCT_SHOPS_SUCCESS);
const requestProductShopsFailure = createAction(REQUEST_PRODUCT_SHOPS_FAILURE);

export function requestProductShops(params) {
  return (dispatch) =>
    Shops.requestProductShops(params)
      .then((data) => dispatch(requestProductShopsSuccess(data)))
      .catch((error) => dispatch(requestProductShopsFailure(error)));
}

const requestEtsyCategoriesSuccess = createAction(
  REQUEST_ETSY_CATEGORIES_SUCCESS
);
const requestEtsyCategoriesFailure = createAction(
  REQUEST_ETSY_CATEGORIES_FAILURE
);

export function requestEtsyCategories(params) {
  return (dispatch) =>
    Shops.requestEtsyCategories(params)
      .then((data) => dispatch(requestEtsyCategoriesSuccess(data)))
      .catch((error) => dispatch(requestEtsyCategoriesFailure(error)));
}

const requestEtsyTaxonomyV2Success = createAction(
  REQUEST_ETSY_CATEGORIES_SUCCESS
);
const requestEtsyTaxonomyV2Failure = createAction(
  REQUEST_ETSY_CATEGORIES_FAILURE
);

export function requestEtsyTaxonomyV2(params) {
  return (dispatch) =>
    Shops.requestEtsyTaxonomyV2(params)
      .then((data) => dispatch(requestEtsyTaxonomyV2Success(data)))
      .catch((error) => dispatch(requestEtsyTaxonomyV2Failure(error)));
}

const requestEtsyTemplatesSuccess = createAction(
  REQUEST_ETSY_TEMPLATES_SUCCESS
);
const requestEtsyTemplatesFailure = createAction(
  REQUEST_ETSY_TEMPLATES_FAILURE
);

export function requestEtsyTemplates(params) {
  return (dispatch) =>
    Shops.requestEtsyTemplates(params)
      .then((data) => dispatch(requestEtsyTemplatesSuccess(data)))
      .catch((error) => dispatch(requestEtsyTemplatesFailure(error)));
}

const requestEtsyShippingProfilesSuccess = createAction(
  REQUEST_ETSY_TEMPLATES_SUCCESS
);
const requestEtsyShippingProfilesFailure = createAction(
  REQUEST_ETSY_TEMPLATES_FAILURE
);

export function requestEtsyShippingProfiles(params) {
  return (dispatch) =>
    Shops.requestEtsyShippingProfiles(params)
      .then((data) => dispatch(requestEtsyShippingProfilesSuccess(data)))
      .catch((error) => dispatch(requestEtsyShippingProfilesFailure(error)));
}

const addToChannelSuccess = createAction(ADD_TO_CHANNEL_SUCCESS);
const addToChannelFailure = createAction(ADD_TO_CHANNEL_FAILURE);

export function addToChannel(params) {
  return (dispatch) =>
    Shops.addToChannel(params)
      .then((data) => dispatch(addToChannelSuccess(data)))
      .catch((error) => dispatch(addToChannelFailure(error)));
}

// BIGCARTEL

const requestBigcartelAuthSuccess = createAction(
  REQUEST_BIGCARTEL_AUTH_URL_SUCCESS
);
const requestBigcartelAuthFailure = createAction(
  REQUEST_BIGCARTEL_AUTH_URL_FAILURE
);

export function requestBigcartelAuth() {
  return (dispatch) =>
    Shops.requestBigcartelAuth()
      .then((data) => dispatch(requestBigcartelAuthSuccess(data)))
      .catch((error) => dispatch(requestBigcartelAuthFailure(error)));
}
const addBigcartelTokenSuccess = createAction(ADD_BIGCARTEL_AUTH_TOKEN_SUCCESS);
const addBigcartelTokenFailure = createAction(ADD_BIGCARTEL_AUTH_TOKEN_FAILURE);

export function addBigcartelToken(params) {
  return (dispatch) =>
    Shops.addBigcartelToken(params)
      .then((data) => dispatch(addBigcartelTokenSuccess(data)))
      .catch((error) => dispatch(addBigcartelTokenFailure(error)));
}
// SQUARESPACE

const requestSquarespaceAuthSuccess = createAction(
  REQUEST_SQUARESPACE_AUTH_URL_SUCCESS
);
const requestSquarespaceAuthFailure = createAction(
  REQUEST_SQUARESPACE_AUTH_URL_FAILURE
);

export function requestSquareSpaceAuth() {
  return (dispatch) =>
    Shops.requestSquarespaceAuth()
      .then((data) => dispatch(requestSquarespaceAuthSuccess(data)))
      .catch((error) => dispatch(requestSquarespaceAuthFailure(error)));
}
const addSquareSpaceTokenSuccess = createAction(
  ADD_SQUARESPACE_AUTH_TOKEN_SUCCESS
);
const addSquareSpaceTokenFailure = createAction(
  ADD_SQUARESPACE_AUTH_TOKEN_FAILURE
);

export function addSquarespaceToken(params) {
  return (dispatch) =>
    Shops.addSquarespaceToken(params)
      .then((data) => dispatch(addSquareSpaceTokenSuccess(data)))
      .catch((error) => dispatch(addSquareSpaceTokenFailure(error)));
}

// EBAY

const requestEbayAuthSuccess = createAction(REQUEST_EBAY_AUTH_URL_SUCCESS);
const requestEbayAuthFailure = createAction(REQUEST_EBAY_AUTH_URL_FAILURE);

export function requestEbayAuth() {
  return (dispatch) =>
    Shops.requestEbayAuth()
      .then((data) => dispatch(requestEbayAuthSuccess(data)))
      .catch((error) => dispatch(requestEbayAuthFailure(error)));
}
const addEbayTokenSuccess = createAction(ADD_EBAY_AUTH_TOKEN_SUCCESS);
const addEbayTokenFailure = createAction(ADD_EBAY_AUTH_TOKEN_FAILURE);

export function addEbayToken(params) {
  return (dispatch) =>
    Shops.addEbayToken(params)
      .then((data) => dispatch(addEbayTokenSuccess(data)))
      .catch((error) => dispatch(addEbayTokenFailure(error)));
}

const requestShipStationShopsSuccess = createAction(SHIP_STATION_SUCCESS);
const requestShipStationShopsFailure = createAction(SHIP_STATION_FAILURE);

export function requestShipStationShops(params) {
  return (dispatch) =>
    Shops.requestShipStationShops(params)
      .then((data) => dispatch(requestShipStationShopsSuccess(data)))
      .catch((error) => dispatch(requestShipStationShopsFailure(error)));
}

const saveShipStationAuthSuccess = createAction(SAVE_SHIP_STATION_AUTH_SUCCESS);
const saveShipStationAuthFailure = createAction(SAVE_SHIP_STATION_AUTH_FAILURE);

export function saveShipStationAuth(params) {
  return (dispatch) =>
    Shops.saveShipStationAuth(params)
      .then((data) => dispatch(saveShipStationAuthSuccess(data)))
      .catch((error) => dispatch(saveShipStationAuthFailure(error)));
}

const addShopAuthSuccess = createAction(ADD_SHOP_AUTH_SUCCESS);
const addShopAuthFailure = createAction(ADD_SHOP_AUTH_FAILURE);

export function addShopAuth(params) {
  return (dispatch) =>
    Shops.addShopAuth(params)
      .then((data) => dispatch(addShopAuthSuccess(data)))
      .catch((error) => dispatch(addShopAuthFailure(error)));
}

const getProductsOfShopSuccess = createAction(GET_PRODUCT_OF_SHOP_SUCCESS);
const getProductsOfShopFailure = createAction(GET_PRODUCT_OF_SHOP_FAILURE);

export function getProductsOfShop(params) {
  return (dispatch) =>
    Shops.getProductsOfShop(params)
      .then((data) => dispatch(getProductsOfShopSuccess(data)))
      .catch((error) => dispatch(getProductsOfShopFailure(error)));
}

const updateProductVisibilitySuccess = createAction(
  UPDATE_PRODUCT_VISIBILITY_SUCCESS
);
const updateProductVisibilityFailure = createAction(
  UPDATE_PRODUCT_VISIBILITY_FAILURE
);

export function updateProductVisibility(params) {
  return (dispatch) =>
    Shops.updateProductVisibility(params)
      .then((data) => dispatch(updateProductVisibilitySuccess(data)))
      .catch((error) => dispatch(updateProductVisibilityFailure(error)));
}

const connectShopSuccess = createAction(CONNECT_SHOP_SUCCESS);
const connectShopFailure = createAction(CONNECT_SHOP_FAILURE);

export function connectShop(params) {
  return (dispatch) =>
    Shops.connectShop(params)
      .then((data) => dispatch(connectShopSuccess(data)))
      .catch((error) => dispatch(connectShopFailure(error)));
}

const updateShopDomainsSuccess = createAction(UPDATE_SHOP_DOMAINS_SUCCESS);
const updateShopDomainsFailure = createAction(UPDATE_SHOP_DOMAINS_FAILURE);

export function updateShopDomains(id, params) {
  return (dispatch) =>
    Shops.updateShopDomains(id, params)
      .then((data) => dispatch(updateShopDomainsSuccess(data)))
      .catch((error) => dispatch(updateShopDomainsFailure(error)));
}

const verifyShopDomainsSuccess = createAction(VERIFY_SHOP_DOMAINS_SUCCESS);
const verifyShopDomainsFailure = createAction(VERIFY_SHOP_DOMAINS_FAILURE);

export function verifyShopDomains(id) {
  return (dispatch) =>
    Shops.verifyShopDomains(id)
      .then((data) => dispatch(verifyShopDomainsSuccess(data)))
      .catch((error) => dispatch(verifyShopDomainsFailure(error)));
}
